// quantity-bundle.js — versão nova e compatível com o novo snippet Liquid

class QuantityBundle {
  constructor(container) {
    this.container = container;

    // Dados essenciais vindos do Liquid
    this.productId = container.dataset.productId;
    this.variantId = container.dataset.variantId;
    this.variantAvailable = container.dataset.variantAvailable === "true";
    this.productHandle = container.dataset.productHandle;

    // Elementos importantes
    this.radioButtons = container.querySelectorAll(
      ".quantity-bundle__radio-input",
    );
    this.buyButton = container.querySelector(".quantity-bundle__buy-button");
    this.unitPriceEl = container.querySelector(".quantity-bundle__price-unit");
    this.comparePriceEl = container.querySelector(
      ".quantity-bundle__compare-price",
    );
    this.currentPriceEl = container.querySelector(
      ".quantity-bundle__current-price",
    );
    this.pixPriceEl = container.querySelector(".quantity-bundle__pix-price");
    this.parcelsPriceEl = container.querySelector(
      ".quantity-bundle__price-parcels",
    );
    this.tagDiscountEl = container.querySelector(
      ".quantity-bundle__discount-tag",
    );

    // Stepper de quantidade — so existe no mobile. No desktop os cards mandam,
    // entao todo acesso a estes elementos passa por isStepperActive().
    this.stepper = container.querySelector("[data-qb-stepper]");
    this.stepperInput = container.querySelector("[data-qb-stepper-input]");
    this.stepperTotalEl = container.querySelector("[data-qb-stepper-total]");
    this.stepperMin = this.stepper
      ? parseInt(this.stepper.dataset.min) || 1
      : 1;
    this.stepperMax = this.stepper
      ? parseInt(this.stepper.dataset.max) || 12
      : 12;
    this.mobileQuery = window.matchMedia("(max-width: 749px)");

    // === NOVO: valores vindos prontos do Liquid ===
    this.parcelas = parseFloat(this.parcelsPriceEl.dataset.parcelas || 1);

    // === Valores de economia (centavos) enviados via data-savings ===
    const savingsStr = container.dataset.savings || "0";
    this.savingsCents = savingsStr.split("/").map((v) => parseFloat(v) || 0);

    // === NOVO: capturar quantidades diretamente do HTML ===
    this.quantities = [
      ...container.querySelectorAll(".quantity-bundle__option"),
    ].map((opt) => parseInt(opt.dataset.quantity));

    // Preço base do produto (centavos → reais)
    this.basePrice = parseFloat(this.currentPriceEl.dataset.currentPrice) / 100;

    // Desconto PIX (%)
    this.pixDiscount = parseFloat(this.pixPriceEl.dataset.pixDiscount || 0);

    // Estado inicial
    const { value, position } = this.getSelectedQuantityAndPosition();

    this.selectedQuantity = value;
    this.position = position;

    this.init();
  }

  init() {
    this.bindEvents();
    this.updatePrices();
    this.updateStepperState();
    this.setupButton();
  }

  setupButton() {
    this.originalButtonText = this.buyButton.textContent;
  }

  bindEvents() {
    this.radioButtons.forEach((radio) => {
      radio.addEventListener("change", () => {
        this.selectedQuantity = parseInt(radio.value);
        this.position = parseInt(radio.dataset.position);

        // Sentido card -> stepper, para os dois nao divergirem ao trocar de
        // breakpoint. O clamp evita que um card fora do intervalo (se alguem
        // configurar 20 no editor) escreva um valor invalido no input.
        if (this.stepperInput) {
          this.stepperInput.value = this.clampQuantity(this.selectedQuantity);
        }

        this.updatePrices();
        this.updateVisualSelection();
        this.updateStepperState();
      });
    });

    if (this.stepper) {
      this.stepper.querySelectorAll("[data-qb-step]").forEach((button) => {
        button.addEventListener("click", () => {
          this.setQuantity(
            this.selectedQuantity + (parseInt(button.dataset.qbStep) || 0),
          );
        });
      });

      // Digitacao: o "input" so reage a um numero ja valido, senao apagar o
      // campo para redigitar reescreveria o valor embaixo do dedo. O "change"
      // (blur / Enter) e quem normaliza o que sobrou.
      this.stepperInput.addEventListener("input", () => {
        const typed = parseInt(this.stepperInput.value);
        if (
          !isNaN(typed) &&
          typed >= this.stepperMin &&
          typed <= this.stepperMax
        ) {
          this.setQuantity(typed);
        }
      });

      this.stepperInput.addEventListener("change", () => {
        this.setQuantity(this.stepperInput.value);
      });

      // Ao cruzar o breakpoint a fonte da verdade troca; realinha os dois lados.
      const onBreakpointChange = () => {
        const state = this.getSelectedQuantityAndPosition();
        this.setQuantity(state.value);
      };

      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener("change", onBreakpointChange);
      } else if (this.mobileQuery.addListener) {
        this.mobileQuery.addListener(onBreakpointChange);
      }
    }

    this.container
      .querySelectorAll(".quantity-bundle__option")
      .forEach((option) => {
        option.addEventListener("click", (e) => {
          if (e.target.type !== "radio") {
            const radio = option.querySelector(".quantity-bundle__radio-input");
            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event("change"));
            }
          }
        });
      });

    this.buyButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.addToCart();
    });
  }

  getSelectedQuantityAndPosition() {
    // No mobile a fonte da verdade e o stepper: ele aceita qualquer valor do
    // intervalo, inclusive quantidades sem card correspondente.
    if (this.isStepperActive()) {
      const value = this.clampQuantity(parseInt(this.stepperInput.value));
      return { value: value, position: this.positionForQuantity(value) };
    }

    const checked = this.container.querySelector(
      ".quantity-bundle__radio-input:checked",
    );

    // Sem radio marcado o codigo antigo estourava ao ler .dataset.position.
    if (!checked) {
      const fallback = this.clampQuantity(this.quantities[0] || this.stepperMin);
      return { value: fallback, position: this.positionForQuantity(fallback) };
    }

    return {
      value: parseInt(checked.value),
      position: parseInt(checked.dataset.position),
    };
  }

  isStepperActive() {
    return !!this.stepperInput && this.mobileQuery.matches;
  }

  clampQuantity(qty) {
    const value = parseInt(qty);
    if (isNaN(value)) return this.stepperMin;
    return Math.min(Math.max(value, this.stepperMin), this.stepperMax);
  }

  // A economia continua vindo por posicao (data-savings). Quando a quantidade
  // escolhida bate com um card configurado, a faixa dele vale; fora disso a
  // posicao e 0 e o indice -1 cai em savings 0 — preco linear.
  positionForQuantity(qty) {
    const option = this.container.querySelector(
      '.quantity-bundle__option[data-quantity="' + qty + '"]',
    );
    return option ? parseInt(option.dataset.position) || 0 : 0;
  }

  setQuantity(qty) {
    const value = this.clampQuantity(qty);

    this.selectedQuantity = value;
    this.position = this.positionForQuantity(value);

    if (this.stepperInput && this.stepperInput.value !== String(value)) {
      this.stepperInput.value = value;
    }

    this.syncRadioToQuantity(value);
    this.updatePrices();
    this.updateStepperState();
  }

  // Mantem os cards coerentes com o stepper para quem alterna de breakpoint
  // (girar o aparelho, o toggle do editor de tema). Quantidades sem card
  // equivalente deixam os radios como estao — nao ha o que marcar.
  syncRadioToQuantity(qty) {
    const radio = this.container.querySelector(
      '.quantity-bundle__radio-input[value="' + qty + '"]',
    );
    if (radio && !radio.checked) {
      radio.checked = true;
      this.updateVisualSelection();
    }
  }

  updateStepperState() {
    if (!this.stepper) return;

    this.stepper.querySelectorAll("[data-qb-step]").forEach((button) => {
      const step = parseInt(button.dataset.qbStep);
      const next = this.selectedQuantity + step;
      button.disabled = next < this.stepperMin || next > this.stepperMax;
    });
  }

  updatePrices() {
    const qtySelected = this.selectedQuantity;
    const positionSelected = this.position;

    // const index = this.quantities.indexOf(positionSelected);
    // const discountPercentRaw = this.discounts[index] || 0;

    // O index agora é a posição em que aparecem as opções ao invés de acessar o index com base na quantidade

    const index = positionSelected - 1;
    const savingsCents = this.savingsCents[index] || 0;
    const savingsAmount = savingsCents / 100;

    // Preço total com desconto
    const totalCompare = this.basePrice * qtySelected;
    const totalCurrent = totalCompare - savingsAmount;

    const discountPercentRounded =
      totalCompare > 0 ? Math.round((savingsAmount / totalCompare) * 100) : 0;

    // Preço unidade
    const priceUnit = qtySelected > 0 ? totalCurrent / qtySelected : 0;

    // Pix
    const pixDecimal = (100 - this.pixDiscount) / 100;
    const pixPrice = totalCurrent * pixDecimal;

    // Parcelado
    const parcelasValue = totalCurrent / this.parcelas;

    // Atualizar preços no DOM
    this.unitPriceEl.textContent = `${this.formatPrice(priceUnit)} cada`;
    this.currentPriceEl.textContent = this.formatPrice(totalCurrent);
    this.parcelsPriceEl.textContent = `ou ${
      this.parcelas
    }x de ${this.formatPrice(parcelasValue)}`;
    this.pixPriceEl.innerHTML = `${this.formatPrice(
      pixPrice,
    )} ${this.pixPriceEl.textContent.split(" ").slice(-2).join(" ")}`;

    // Aplicar valor arredondado na tag
    this.tagDiscountEl.textContent = `${discountPercentRounded}% OFF`;

    // Total ao lado do stepper — no mobile e o unico lugar onde o cliente ve
    // quanto vai pagar, porque o bloco .quantity-bundle__pricing esta oculto.
    if (this.stepperTotalEl) {
      this.stepperTotalEl.textContent = this.formatPrice(totalCurrent);
    }

    // === NOVO: mostrar ou esconder elementos ===
    if (savingsCents <= 0) {
      this.comparePriceEl.style.display = "none";
      this.tagDiscountEl.style.display = "none";
    } else {
      this.comparePriceEl.style.display = "";
      this.tagDiscountEl.style.display = "";
      this.comparePriceEl.textContent = this.formatPrice(totalCompare);
    }
  }

  updateComparePriceVisibility(index) {
    if (index === 0) {
      this.comparePriceEl.style.display = "none";
    } else {
      this.comparePriceEl.style.display = "";
    }
  }

  updateVisualSelection() {
    this.container
      .querySelectorAll(".quantity-bundle__option")
      .forEach((opt) =>
        opt.classList.remove("quantity-bundle__option--selected"),
      );

    const selected = this.container.querySelector(
      ".quantity-bundle__radio-input:checked",
    );
    if (selected) {
      selected
        .closest(".quantity-bundle__option")
        .classList.add("quantity-bundle__option--selected");
    }
  }

  // Ate 2 unidades nenhum total passava de mil, entao o formato antigo
  // (toFixed + troca do ponto por virgula) nunca precisou de separador de
  // milhar. Com o stepper indo a 12 ele passa, e "R$ 1152,00" nao bate com o
  // filtro `money` do Liquid, que renderiza "R$ 1.152,00".
  formatPrice(price) {
    return (
      "R$ " +
      price.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }

  async addToCart() {
    if (this.buyButton.disabled) return;

    try {
      this.buyButton.disabled = true;
      this.buyButton.textContent = "Adicionando...";

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: this.variantId,
          quantity: this.selectedQuantity,
        }),
      });

      if (!response.ok) throw new Error("Erro ao adicionar ao carrinho");

      this.showSuccessFeedback();
      setTimeout(() => this.openCartDrawer(), 300);
    } catch (err) {
      console.error(err);
      this.showErrorFeedback();
    }
  }

  showSuccessFeedback() {
    this.buyButton.textContent = "✓ Adicionado!";
    setTimeout(() => this.restoreButton(), 2000);
  }

  showErrorFeedback() {
    this.buyButton.textContent = "Erro - tente novamente";
    setTimeout(() => this.restoreButton(), 2500);
  }

  restoreButton() {
    this.buyButton.disabled = false;
    this.buyButton.textContent = this.originalButtonText;
  }

  async openCartDrawer() {
    const response = await fetch("/?sections=cart-drawer,cart-icon-bubble");
    const sections = await response.json();
    const parsedState = { sections };

    const drawer = document.querySelector("cart-drawer");
    if (!drawer) return;

    drawer.classList.remove("is-empty");
    drawer.renderContents(parsedState);

    requestAnimationFrame(() => {
      drawer.classList.add("animate", "active");
      document.body.classList.add("overflow-hidden");
    });
  }
}

// AUTO INIT
function initQuantityBundles() {
  document.querySelectorAll(".quantity-bundle").forEach((bundle) => {
    new QuantityBundle(bundle);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initQuantityBundles);
} else {
  initQuantityBundles();
}

document.addEventListener("shopify:section:load", (e) => {
  e.target
    .querySelectorAll(".quantity-bundle")
    .forEach((bundle) => new QuantityBundle(bundle));
});
